import React from 'react';
import { useTranslation } from 'react-i18next';
import Spinner from '../load/Spinner';
import './loadButton.css';

function LoadButton({
  onClick,
  load,
  classNameButtom = '',
  minWidth = '180px',
  height = '58px',
  style = {},
  id = '',
  text = 'Continuar',
  disabled = false,
  type = 'onSubmit'
}) {
  const { t } = useTranslation();

  return !load ? (
    <button
      id={id}
      className={`text-truncate btn btn-blue justify-content-center ${classNameButtom}`}
      type={type}
      onClick={e => {
        if (onClick) onClick(e);
      }}
      style={{ minWidth, height, ...style }}
      disabled={disabled}
    >
      {t(text)}
    </button>
  ) : (
    <div
      className={`d-flex align-items-center justify-content-center ${classNameButtom}`}
      style={{ minWidth, height, width: 'auto', backgrounColor: 'transparent !important' }}
    >
      <Spinner style={{ ...style }} />
    </div>
  );
}
export default LoadButton;
